import React from "react";

function Subtitle({ text }) {
  return <p className="single-event__header--subtitle">{text}</p>;
}

export default Subtitle;
